import { createClient } from "@supabase/supabase-js";

const getEnvVar = (name: string, value: string | undefined): string => {
  if (typeof value !== "string" || value.trim() === "") {
    throw new Error(
      `Missing or empty required environment variable: ${name}. ` +
        "Please define it in your environment (e.g. .env, deployment config) before running the app."
    );
  }
  return value;
};

// Supabase Admin
const supabaseAdminUrl = getEnvVar("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL);
const supabaseAdminKey = getEnvVar("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY);
// Supabase Stats
const supabaseStatsUrl = getEnvVar(
  "VITE_SUPABASE_STATS_PROJECT_URL",
  import.meta.env.VITE_SUPABASE_STATS_PROJECT_URL || import.meta.env.VITE_SUPABASE_URL_STATS
);
const supabaseStatsKey = getEnvVar(
  "VITE_SUPABASE_STATS_PROJECT_ANON_KEY",
  import.meta.env.VITE_SUPABASE_STATS_PROJECT_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY_STATS
);

export const supabaseAdmin = createClient(supabaseAdminUrl, supabaseAdminKey);
export const supabaseStats = createClient(supabaseStatsUrl, supabaseStatsKey);